import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useSelector } from "react-redux";

const RegistrationPromptContext = createContext();
export const useRegistrationPrompt = () => useContext(RegistrationPromptContext);

const STORAGE_KEYS = {
  INTERACTION_COUNT: "katarza_subscribe_prompt_click_count",
  SHOWN_MILESTONES: "katarza_subscribe_prompt_shown_milestones",
};

const MAX_SESSION_MODALS = 3;
const PROMPT_CLICK_THRESHOLD = 3;

export const RegistrationPromptProvider = ({ children, disabled = false }) => {
  const { userData } = useSelector((state) => state.userReducer);
  const isLoggedIn = !!userData?.firstName;
  const [showPrompt, setShowPrompt] = useState(false);
  const [sessionShown, setSessionShown] = useState(0);

  useEffect(() => {
    if (disabled) setShowPrompt(false);
  }, [disabled]);

  useEffect(() => {
    if (isLoggedIn || disabled) {
      return undefined;
    }

    const handleInteraction = () => {
      if (showPrompt || sessionShown >= MAX_SESSION_MODALS) {
        return;
      }

      const interactionCount =
        parseInt(localStorage.getItem(STORAGE_KEYS.INTERACTION_COUNT) || "0", 10) + 1;
      const shownMilestones = JSON.parse(
        localStorage.getItem(STORAGE_KEYS.SHOWN_MILESTONES) || "[]"
      );
      localStorage.setItem(
        STORAGE_KEYS.INTERACTION_COUNT,
        interactionCount.toString()
      );

      if (
        interactionCount >= PROMPT_CLICK_THRESHOLD &&
        !shownMilestones.includes(PROMPT_CLICK_THRESHOLD)
      ) {
        localStorage.setItem(
          STORAGE_KEYS.SHOWN_MILESTONES,
          JSON.stringify([...shownMilestones, PROMPT_CLICK_THRESHOLD])
        );
        setShowPrompt(true);
        setSessionShown((prev) => prev + 1);
      }
    };

    document.addEventListener("click", handleInteraction, true);

    return () => {
      document.removeEventListener("click", handleInteraction, true);
    };
  }, [disabled, isLoggedIn, sessionShown, showPrompt]);

  const dismissPrompt = useCallback(() => setShowPrompt(false), []);

  return (
    <RegistrationPromptContext.Provider
      value={{ showPrompt: disabled ? false : showPrompt, dismissPrompt }}
    >
      {children}
    </RegistrationPromptContext.Provider>
  );
};
